<template>
	<div class="input checkbox" :class="{ 'input-error': errors[id] }">
		<input :id="id" type="checkbox" v-model="form[id]">
		<label :for="id" v-if="name">{{ name }}</label>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	export default {
		props: ['id', 'name', 'form', 'errors'],
	}
</script>

<style lang="scss" scoped>
	.checkbox {
		
	}
</style>


// WEBPACK FOOTER //
// src/components/Form/InputCheckbox.vue